import styled, { css } from 'styled-components'
import media from 'styled-media-query'

type InputsContainerProps = {
  grid: number
}

export const CardContainer = styled.div`
  ${({ theme }) => css`
    box-shadow: 3px 3px 1px rgb(0 0 0 / 10%);
    border-radius: 16px;
    margin: 10px 20px;
    padding: 20px;
    background: ${theme.colors.mainBg};
    color: ${theme.colors.primary};
  `}
`

export const headerCard = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  > button {
    position: absolute;
    right: -8px;
    top: 0px;
    background: none;
    cursor: pointer;
  }
`

export const InputsContainer = styled.div<InputsContainerProps>`
  ${({ theme, grid }) => css`
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(${grid}, 1fr);
    padding: 10px;
    background: #f2f2f2;
    color: ${theme.colors.primary};

    ${media.lessThan('medium')`
      grid-template-columns: repeat(1, 1fr);
    `}
  `}
`
